import React from "react";
import Layout from "./components/Layout";

function Privacy() {
  return (
    <Layout title="Datenschutz">
      <div className="card" style={{ maxWidth: "900px", margin: "0 auto" }}>
        <div style={{
          fontSize: "var(--font-size-sm)",
          lineHeight: "1.7",
          color: "var(--text-primary)"
        }}>
          <h1 style={{ fontSize: "1.75rem", marginBottom: "var(--space-4)" }}>Datenschutzerklärung</h1>

          <h2 style={{ fontSize: "1.25rem", marginTop: "var(--space-6)", marginBottom: "var(--space-3)" }}>
            Informationen über die Erhebung von personenbezogenen Daten
          </h2>
          <p>
            Diese Datenschutzerklärung gibt Auskunft darüber, welche personenbezogen Daten wir erheben,
            die Zwecke, zu denen wir sie verwenden, sowie die Rechtsgrundlage, auf der wir sie verarbeiten.
            Sie umfasst auch, ob und wie diese Daten weitergegeben werden dürfen und welche Rechte und
            Auswahlmöglichkeiten Sie in Bezug auf die personenbezogen Daten haben, die Sie uns zur Verfügung
            stellen. Diese Datenschutzerklärung gilt für Daten, die wir im Rahmen Ihrer Nutzung von
            <strong> app.hedit.ch</strong> erheben.
          </p>

          <h2 style={{ fontSize: "1.25rem", marginTop: "var(--space-6)", marginBottom: "var(--space-3)" }}>
            Verantwortlicher
          </h2>
          <p>
            <strong>HEDIT GmbH</strong><br />
            Acherweg 68<br />
            6370 Stans<br />
            Schweiz
          </p>
          <p>
            E-Mail: frankenspalter@hedit.ch<br />
            Telefon: +41 79 370 05 35
          </p>

          <h2 style={{ fontSize: "1.25rem", marginTop: "var(--space-6)", marginBottom: "var(--space-3)" }}>
            Von uns erfasste Daten
          </h2>
          <p>
            Damit wir Ihnen unseren Vermögensverwaltungs-Service bieten können, müssen wir bestimmte
            Informationen erheben und bearbeiten. Je nachdem, wie Sie unsere Dienste nutzen, kann dies
            Folgendes umfassen:
          </p>

          <h3 style={{ fontSize: "1.1rem", marginTop: "var(--space-4)", marginBottom: "var(--space-2)" }}>
            Registrierung und Login
          </h3>
          <p>
            Bei der Registrierung erheben wir Ihre <strong>E-Mail-Adresse</strong> und ein
            <strong> verschlüsseltes Passwort</strong> (gehasht mit bcrypt). Diese Daten werden verwendet,
            um Ihr Konto zu erstellen und Sie zu authentifizieren.
          </p>

          <h3 style={{ fontSize: "1.1rem", marginTop: "var(--space-4)", marginBottom: "var(--space-2)" }}>
            Finanzdaten
          </h3>
          <p>
            Sie geben freiwillig Vermögensdaten (Kategorien, Beträge, Währungen, Notizen) ein, die wir für
            Sie speichern und verarbeiten, um Ihnen Übersichten und Analysen anzuzeigen. Diese Daten werden
            ausschliesslich für Ihre persönliche Vermögensverwaltung verwendet.
          </p>

          <h2 style={{ fontSize: "1.25rem", marginTop: "var(--space-6)", marginBottom: "var(--space-3)" }}>
            Demo-Account
          </h2>
          <p>
            Wir bieten einen öffentlichen Demo-Account an, der keine persönlichen Daten enthält. Dieser
            Account dient ausschliesslich zu Demonstrationszwecken und enthält fiktive Vermögensdaten.
          </p>

          <h2 style={{ fontSize: "1.25rem", marginTop: "var(--space-6)", marginBottom: "var(--space-3)" }}>
            Ihre Rechte bei der Nutzung unserer Website
          </h2>
          <p>Sie haben folgende Rechte in Bezug auf Ihre personenbezogenen Daten:</p>
          <ul style={{ marginLeft: "var(--space-4)", lineHeight: "1.9" }}>
            <li><strong>Auskunftsrecht</strong>: Sie haben das Recht auf Auskunft über die personenbezogenen Daten, die wir über Sie gespeichert haben.</li>
            <li><strong>Berichtigungsrecht</strong>: Sie können die Berichtigung unrichtiger Daten verlangen.</li>
            <li><strong>Löschungsrecht</strong>: Sie können die Löschung Ihres Accounts und aller damit verbundenen Daten jederzeit verlangen.</li>
            <li><strong>Einschränkung der Verarbeitung</strong>: Sie können die Einschränkung der Verarbeitung Ihrer Daten verlangen.</li>
            <li><strong>Datenübertragbarkeit</strong>: Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.</li>
          </ul>
          <p>
            Falls Sie die oben erläuterten Rechte hinsichtlich Ihrer personenbezogenen Daten ausüben möchten
            und/oder bei Fragen bezüglich der Verarbeitung Ihrer personenbezogenen Daten durch uns, wenden
            Sie sich bitte an <strong>frankenspalter@hedit.ch</strong>.
          </p>
          <p>
            Darüber hinaus haben Sie das Recht, eine Beschwerde bei der Datenschutzbehörde in Ihrer
            Gerichtsbarkeit einzureichen.
          </p>

          <h2 style={{ fontSize: "1.25rem", marginTop: "var(--space-6)", marginBottom: "var(--space-3)" }}>
            Hosting und Datenspeicherung
          </h2>
          <p>
            Alle Ihre Daten werden ausschliesslich in der <strong>Schweiz</strong> gehostet und verarbeitet.
            Zum Hosten der Website, der API und der Datenbank nutzen wir:
          </p>
          <p>
            <strong>Infomaniak Network SA</strong><br />
            Avenue de la Praille 26<br />
            1227 Carouge / Genève<br />
            Schweiz
          </p>
          <p>
            <strong>Wichtig</strong>: Ihre Daten verlassen niemals die Schweiz. Infomaniak ist ein Schweizer Unternehmen
            mit Rechenzentren ausschliesslich in der Schweiz und unterliegt dem strengen Schweizer Datenschutzgesetz (DSG).
            Infomaniak ist nach ISO 27001 zertifiziert und erfüllt höchste Sicherheits- und Datenschutzstandards.
          </p>

          <h2 style={{ fontSize: "1.25rem", marginTop: "var(--space-6)", marginBottom: "var(--space-3)" }}>
            Datensicherheit
          </h2>
          <p>
            Wir setzen technische und organisatorische Sicherheitsmassnahmen ein, um Ihre Daten gegen
            zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder gegen den Zugriff
            unberechtigter Personen zu schützen:
          </p>
          <ul style={{ marginLeft: "var(--space-4)", lineHeight: "1.9" }}>
            <li><strong>Verschlüsselte Übertragung</strong>: Alle Datenübertragungen erfolgen über HTTPS (SSL/TLS)</li>
            <li><strong>Passwort-Hashing</strong>: Passwörter werden mit bcrypt gehasht und nie im Klartext gespeichert</li>
            <li><strong>Datentrennung</strong>: Jeder Benutzer kann nur auf seine eigenen Daten zugreifen</li>
            <li><strong>JWT-Authentifizierung</strong>: Sichere Token-basierte Authentifizierung</li>
          </ul>

          <h2 style={{ fontSize: "1.25rem", marginTop: "var(--space-6)", marginBottom: "var(--space-3)" }}>
            Aufbewahrung von Daten
          </h2>
          <p>
            Wir bewahren Ihre personenbezogenen Daten so lange auf, wie Ihr Konto aktiv ist oder wie dies
            zur Erbringung der jeweiligen Dienstleistungen erforderlich ist.
          </p>
          <p>
            <strong>Löschung Ihres Accounts</strong>: Sie können Ihr Konto jederzeit löschen lassen, woraufhin
            alle Ihre Daten unwiderruflich aus unserer Datenbank gelöscht werden. Kontaktieren Sie uns hierzu
            unter frankenspalter@hedit.ch.
          </p>
          <p>
            Wir werden Daten auch aufbewahren und verwenden, soweit dies zur Einhaltung unserer gesetzlichen
            Verpflichtungen erforderlich ist.
          </p>

          <h2 style={{ fontSize: "1.25rem", marginTop: "var(--space-6)", marginBottom: "var(--space-3)" }}>
            Änderungen dieser Datenschutzerklärung
          </h2>
          <p>
            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen
            rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung
            umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
          </p>

          <hr style={{ margin: "var(--space-6) 0", border: "none", borderTop: "1px solid var(--border-color)" }} />

          <p style={{ fontSize: "var(--font-size-sm)", color: "var(--text-secondary)" }}>
            <strong>Stand</strong>: 12.11.2025
          </p>
        </div>
      </div>
    </Layout>
  );
}

export default Privacy;
